import { Shown } from './Shown';

export const ComingSoon = ({ children, extraClass = '' }: { children?: JSX.Element; extraClass?: string }) => {
  return (
    <div className={`ComingSoon ${extraClass}`}>
      {children && children}
      <div className="ComingSoonFlag" />
    </div>
  );
};

export const ComingSoonBanner = ({ children, extraClass = '' }: { children?: JSX.Element; extraClass?: string }) => {
  return (
    <Shown>
      <div className={`ComingSoonBanner ${extraClass}`}>
        {/* eslint-disable-next-line react/no-children-prop */}
        <ComingSoon children={children} extraClass={extraClass} />
      </div>
    </Shown>
  );
};
